const TitleBar = () => (
  <div className="h-8 w-full bg-[white] fixed z-20 flex items-center">
    <p className="text-center font-bold text-m absolute top-0 left-0 right-0 leading-8">
      <span id="console-title" className="relative text-black">
        ohicee@github.com
      </span>
    </p>
    <div className="flex group h-full items-center z-30">
      <div className="h-4 w-4 bg-pink rounded-full mr-2 ml-3 relative cursor-pointer">
        <div className="h-[0.3rem] w-[0.3rem] bg-black opacity-50 rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
      </div>
      <div className="h-4 w-4 bg-yellow rounded-full mr-2 relative cursor-pointer">
        <div className="group-hover:opacity-50 opacity-0 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pb-0.5 pointer-events-none font-bold">
          —
        </div>
      </div>
      <div className="h-4 w-4 bg-teal rounded-full mr-2 relative cursor-pointer">
        <img
          src="macos-maximize.png"
          alt="macos maximize"
          className="group-hover:opacity-50 w-1/2 h-1/2 opacity-0 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        />
      </div>
    </div>
  </div>
);

export default TitleBar;
